var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("header", { staticClass: "header" }, [
        _c("div", { staticClass: "header_left" }, [
          _c("span", { on: { click: _vm.goBack } }, [
            _c("i", { staticClass: "mintui mintui-back" }),
            _vm._v("返回")
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "header_right" }, [
          _c("span", { on: { click: _vm.goBack } }, [_vm._v("取消")])
        ])
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "video" },
        [
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.isAudio,
                  expression: "isAudio"
                }
              ]
            },
            [
              _c("div", [
                _c("img", {
                  staticStyle: { width: "200px", "border-radius": "4px" },
                  attrs: { src: this.audioJpg }
                })
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "audioOff" }, [
                _c("div", { staticClass: "ofplayBox" }, [
                  _c("audio", {
                    ref: "videoPlayer",
                    attrs: {
                      id: "audio",
                      src: this.lesson.audiourl,
                      playsinline: _vm.playsinline,
                      options: _vm.playerOptions
                    },
                    on: {
                      error: function($event) {
                        return _vm.onPlayerError($event)
                      },
                      pause: function($event) {
                        return _vm.onPlayerPause($event)
                      },
                      play: function($event) {
                        return _vm.onPlayerAudioPlay($event)
                      },
                      ended: function($event) {
                        return _vm.onPlayerEnded($event)
                      },
                      timeupdate: function($event) {
                        return _vm.onPlayerTimeAudioupdate($event)
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "isPlayImg" },
                    [
                      !_vm.playflg
                        ? _c(
                            "mt-button",
                            {
                              on: {
                                click: function($event) {
                                  return _vm.play()
                                }
                              }
                            },
                            [_vm._v("播放")]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.playflg
                        ? _c(
                            "mt-button",
                            {
                              on: {
                                click: function($event) {
                                  return _vm.stop()
                                }
                              }
                            },
                            [_vm._v("暂停")]
                          )
                        : _vm._e()
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "progress" },
                    [
                      _c("mt-range", {
                        attrs: {
                          value: _vm.rangeValue,
                          step: 10,
                          max: _vm.offset
                        },
                        model: {
                          value: _vm.rangeValue,
                          callback: function($$v) {
                            _vm.rangeValue = $$v
                          },
                          expression: "rangeValue"
                        }
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "duration" }, [
                        _c("span", [_vm._v(_vm._s(_vm.starttime))]),
                        _c("span", { staticClass: "right-timer" }, [
                          _vm._v(_vm._s(this.duration))
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "cover" })
                    ],
                    1
                  )
                ])
              ])
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.zhezhao,
                  expression: "zhezhao"
                }
              ],
              staticClass: "punch-card-button"
            },
            [
              _c(
                "div",
                {
                  staticClass: "button-content",
                  attrs: { id: "videoHeadInfo" }
                },
                [
                  _c("img", {
                    attrs: {
                      src:
                        "https://imagesbj.sdjtip.com/images/nn/0_2020041622510901456.jpg",
                      alt: ""
                    },
                    on: { click: _vm.onPlayerPlaya }
                  })
                ]
              )
            ]
          ),
          _vm._v(" "),
          _vm.playAble
            ? _c("video-player", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: !_vm.isAudio && !_vm.zhezhao,
                    expression: "!isAudio && !zhezhao "
                  }
                ],
                ref: "videoPlayer",
                staticClass: "video-player vjs-custom-skin",
                attrs: {
                  playsinline: _vm.playsinline,
                  options: _vm.playerOptions
                },
                on: {
                  error: function($event) {
                    return _vm.onPlayerError($event)
                  },
                  play: function($event) {
                    return _vm.onPlayerPlay($event)
                  },
                  pause: function($event) {
                    return _vm.onPlayerPause($event)
                  },
                  ended: function($event) {
                    return _vm.onPlayerEnded($event)
                  },
                  timeupdate: function($event) {
                    return _vm.onPlayerTimeupdate($event)
                  }
                }
              })
            : _c("view", [_vm._v("开始考试")])
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.popupVisiblesc,
              expression: "popupVisiblesc"
            }
          ],
          staticClass: "video"
        },
        [
          _c("span", { staticClass: "content" }, [
            _vm._v("请30秒内完成验证！")
          ]),
          _vm._v(" "),
          _c("div", {
            staticStyle: {
              "margin-top": "5%",
              "margin-bottom": "15px",
              "margin-left": "0%"
            },
            attrs: { id: "sc" }
          })
        ]
      ),
      _vm._v(" "),
      _vm.introOpen
        ? _c(
            "div",
            { staticClass: "intro", style: { height: _vm.contentHeight } },
            [
              _c("div", { staticClass: "title" }, [
                _vm._v(_vm._s(_vm.lesson.title))
              ])
            ]
          )
        : _c("div", { staticClass: "question-and-answer" }, [
            _c("div", { staticClass: "title" }, [_vm._v("答疑")]),
            _vm._v(" "),
            _c("div", { staticClass: "line" }),
            _vm._v(" "),
            _c("div", { staticClass: "time" }, [
              _vm._v(_vm._s(_vm._f("dateformat")(new Date(), "HH:mm")))
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "listPage" },
              [
                _c(
                  "mt-loadmore",
                  {
                    ref: "loadMore",
                    attrs: {
                      "auto-fill": false,
                      "top-method": _vm.loadTop,
                      "bottom-all-loaded": _vm.allLoaded
                    },
                    on: { "bottom-status-change": _vm.handleBottomChange }
                  },
                  [
                    _c(
                      "div",
                      { staticStyle: { "min-height": "200px" } },
                      _vm._l(this.myAnswerList.list, function(item, index) {
                        return _c("div", { key: index }, [
                          item.flag == "question"
                            ? _c("div", { staticClass: "question" }, [
                                _c("span", { staticClass: "content" }, [
                                  _vm._v(_vm._s(item.content))
                                ]),
                                _vm._v(" "),
                                _c("span", { staticClass: "img" }, [
                                  _c("img", { attrs: { src: _vm.personIcon } })
                                ])
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          item.flag == "answer"
                            ? _c("div", { staticClass: "answer" }, [
                                _c("span", { staticClass: "img" }, [
                                  _c("img", { attrs: { src: _vm.personIcon } })
                                ]),
                                _vm._v(" "),
                                _c("span", { staticClass: "content" }, [
                                  _vm._v(_vm._s(item.content))
                                ])
                              ])
                            : _vm._e()
                        ])
                      }),
                      0
                    )
                  ]
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "inputgroup" },
              [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.questionInput,
                      expression: "questionInput"
                    }
                  ],
                  domProps: { value: _vm.questionInput },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.questionInput = $event.target.value
                    }
                  }
                }),
                _vm._v(" "),
                _c(
                  "mt-button",
                  {
                    attrs: { type: "primary", size: "small" },
                    on: { click: _vm.send }
                  },
                  [_vm._v("发送")]
                )
              ],
              1
            )
          ]),
      _vm._v(" "),
      _c("div", [
        _c("section", { attrs: { id: "foot_nav" } }, [
          _c(
            "section",
            { staticClass: "foot_item", on: { click: _vm.getMenu } },
            [
              _c("img", {
                staticClass: "icon_style",
                attrs: { src: _vm.menu }
              }),
              _vm._v(" 目录")
            ]
          ),
          _vm._v(" "),
          this.lesson.audiourl
            ? _c(
                "section",
                { staticClass: "foot_item", on: { click: _vm.audioPlay } },
                [
                  _c("img", {
                    staticClass: "icon_style",
                    attrs: { src: _vm.audio }
                  }),
                  _vm._v(" 音频\n            ")
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "section",
            { staticClass: "foot_item", on: { click: _vm.initVideoPlayer } },
            [
              _c("img", {
                staticClass: "icon_style",
                attrs: { src: _vm.video }
              }),
              _vm._v(" 视频")
            ]
          ),
          _vm._v(" "),
          _c(
            "section",
            { staticClass: "foot_item", on: { click: _vm.getQuestion } },
            [
              _c("img", {
                staticClass: "icon_style",
                attrs: { src: _vm.question }
              }),
              _vm._v(" 答疑")
            ]
          )
        ])
      ]),
      _vm._v(" "),
      _c(
        "exam-dialog",
        _vm._b(
          { ref: "examDialog", on: { confirm: _vm.next, cancle: _vm.last } },
          "exam-dialog",
          _vm.examDialogConfig,
          false
        ),
        [
          _vm.questionList[0]
            ? _c(
                "div",
                {
                  staticClass: "content",
                  staticStyle: { overflow: "scroll", height: "60%" },
                  attrs: { slot: "content" },
                  slot: "content"
                },
                [
                  _c("div", { staticClass: "content" }, [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.questionNo + 1) +
                        ". " +
                        _vm._s(_vm.questionList[_vm.questionNo].content) +
                        "\n            "
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "item no-mint-style" },
                    [
                      this.questionList[this.questionNo].questiontype !=
                      "MULTISELECT"
                        ? _c("mt-radio", {
                            staticClass: "selection-list",
                            attrs: { options: _vm.questionInfo.items },
                            model: {
                              value: _vm.answer[_vm.questionNo],
                              callback: function($$v) {
                                _vm.$set(_vm.answer, _vm.questionNo, $$v)
                              },
                              expression: "answer[questionNo]"
                            }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      this.questionList[this.questionNo].questiontype ==
                      "MULTISELECT"
                        ? _c("mt-checklist", {
                            staticClass: "selection-list",
                            attrs: { options: _vm.questionInfo.items },
                            model: {
                              value: _vm.questionNos[_vm.questionNo],
                              callback: function($$v) {
                                _vm.$set(_vm.questionNos, _vm.questionNo, $$v)
                              },
                              expression: "questionNos[questionNo]"
                            }
                          })
                        : _vm._e()
                    ],
                    1
                  )
                ]
              )
            : _vm._e()
        ]
      ),
      _vm._v(" "),
      _c(
        "exam-dialog",
        _vm._b(
          {
            ref: "examDialog2",
            on: { confirm: _vm.ceshinext, cancle: _vm.last }
          },
          "exam-dialog",
          _vm.examDialogConfig2,
          false
        ),
        [
          _vm.questionList2[0]
            ? _c(
                "div",
                {
                  staticClass: "content",
                  staticStyle: { overflow: "scroll", height: "60%" },
                  attrs: { slot: "content" },
                  slot: "content"
                },
                [
                  _c("div", { staticClass: "content" }, [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.questionList2[_vm.questionNo].content) +
                        "\n            "
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "item no-mint-style" },
                    [
                      _c("mt-radio", {
                        staticClass: "selection-list",
                        attrs: { options: _vm.questionInfo2.items2 },
                        model: {
                          value: _vm.answer["as"],
                          callback: function($$v) {
                            _vm.$set(_vm.answer, "as", $$v)
                          },
                          expression: "answer['as']"
                        }
                      })
                    ],
                    1
                  )
                ]
              )
            : _vm._e()
        ]
      ),
      _vm._v(" "),
      _c(
        "my-dialog",
        _vm._b(
          {
            ref: "myDialog",
            on: { cancle: _vm.cancleExam, confirm: _vm.startExam }
          },
          "my-dialog",
          _vm.dialogConfig,
          false
        )
      ),
      _vm._v(" "),
      _vm.popupVisible
        ? _c(
            "mt-popup",
            {
              staticClass: "mint-popup",
              staticStyle: { position: "fixed", top: "-100" },
              attrs: { position: "bottom" },
              model: {
                value: _vm.popupVisible,
                callback: function($$v) {
                  _vm.popupVisible = $$v
                },
                expression: "popupVisible"
              }
            },
            [
              _c("idverify4Unit", {
                attrs: { datainfos: _vm.datainfos },
                on: {
                  change: _vm.checkCompareResult,
                  FaceRecognitionfunction: _vm.FaceRecognitionfunction
                }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "mt-popup",
        {
          staticClass: "mint-popup",
          attrs: { closeOnClickModal: !_vm.isFullscreen, position: "right" },
          model: {
            value: _vm.isFullscreen,
            callback: function($$v) {
              _vm.isFullscreen = $$v
            },
            expression: "isFullscreen"
          }
        },
        [
          _c(
            "div",
            { staticClass: "pdf", style: _vm.contentStyleObj },
            [
              _vm.reviewFlag
                ? _c(
                    "levitatedSphere",
                    { attrs: { position: _vm.levitatedSpherePosition } },
                    [
                      _c(
                        "div",
                        { staticClass: "page-study-progress" },
                        [
                          _c(
                            "mt-progress",
                            {
                              attrs: {
                                value:
                                  (_vm.pageStudyDuration /
                                    _vm.pageStudyDurationUnit) *
                                  100,
                                "bar-height": 10
                              }
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    "margin-right": "5px",
                                    color: "#ef0808"
                                  },
                                  attrs: { slot: "start" },
                                  slot: "start"
                                },
                                [_vm._v("距离下一章节:")]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { attrs: { slot: "end" }, slot: "end" },
                                [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        parseInt(_vm.pageStudyDuration / 1000)
                                      )
                                    )
                                  ]),
                                  _c("span", [_vm._v("秒")])
                                ]
                              )
                            ]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "reviewLimitTimeBox" }, [
                        _c(
                          "div",
                          { staticStyle: { margin: "0 auto", width: "90%" } },
                          [
                            _c("span", { staticStyle: { float: "left" } }, [
                              _vm._v("预习时间还有(")
                            ]),
                            _vm._v(" "),
                            _c("count-down", {
                              attrs: {
                                currentTime: _vm.countDownTime.startTime,
                                startTime: _vm.countDownTime.startTime,
                                endTime: _vm.countDownTime.endTime,
                                tipTextEnd: "距离下课时间",
                                minutesTxt: "分",
                                secondsTxt: "秒)"
                              },
                              on: {
                                start_callback: function($event) {
                                  return _vm.reviewTimeCountDown(1)
                                },
                                end_callback: function($event) {
                                  return _vm.endNonTeachStudyLesson()
                                }
                              }
                            })
                          ],
                          1
                        )
                      ])
                    ]
                  )
                : _vm._e()
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _vm.recordvideodialog
        ? _c("recordvideo", { attrs: { datainfos: _vm.datainfos } })
        : _vm._e(),
      _vm._v(" "),
      _vm.FaceRecognitionVisible
        ? _c(
            "mt-popup",
            {
              staticStyle: { width: "100%", height: "90%" },
              attrs: { position: "bottom" },
              model: {
                value: _vm.FaceRecognitionVisible,
                callback: function($$v) {
                  _vm.FaceRecognitionVisible = $$v
                },
                expression: "FaceRecognitionVisible"
              }
            },
            [
              _c("FaceRecognition", {
                ref: "FaceRecognition",
                on: { closevideoMedia: _vm.closevideoMedia }
              })
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-200a85c4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-200a85c4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/index/course/lesson.vue
// module id = null
// module chunks = 